import React from 'react'
import './Historia.css'

const Historia = () => {
  return (
    <div className="historiaPage">
      <div className="historiaCard">
        <div className="historiaBadge">Breve</div>
        <h1 className="historiaTitle">Nossa trajetória</h1>
        <p className="historiaText">
          A Associação de Surdos de Juiz de Fora (ASJF) tem uma história de compromisso com a classe e a comunidade.
          Aqui você encontrará um breve resumo sobre as origens e as principais conquistas que moldaram nossa atuação.
        </p>
      </div>
    </div>
  )
}

export default Historia